module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-mobile@3x-17c7b7ca0259d12340e4269ba39649c0.jpg";